'use strict';
define('elements/link-select',['jquery'], function($, undefined) {
	$(document).ready(function() {
			$('body').on('change', 'select.search-wizard__link-select', function() {
				window.location.href = $(this).val();
			});
		}
	);
});
